<template>
  <div @click.stop="onToggle($event)" class="dropdown" @blur="onBlur" :tabindex="tabIndex">
    <span @click.prevent.stop="conditionalToggle ? onToggle() : null" class="toggle">
      <slot ref="toggle" name="toggle" :open="open"></slot>
    </span>
    <!-- <div class="menu-wrapper"> -->
    <div
      v-show="open && !disabled"
      class="menu"
      ref="dropdownmenu"
      :class="{
        left: left,
        right: right,
        'right-top': rightTop,
        'left-top': leftTop,
        padding: !noPadding,
        'dark-background': darkBackground
      }"
      :style="[leftTop ? { 'min-width': minWidth + 'px', top: '-' + ( leftTopPlacement ) + 'px'} : {'min-width': minWidth + 'px'}]"
    >
      <slot :open="open"></slot>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "dropdown",
  props: {
    disabled: { type: Boolean, default: false },
    EventBus: { type: Object },
    text: { type: String, required: false, default: "Toggle" },
    minWidth: { type: [Number, String] },
    conditionalToggle: { type: Boolean, default: true },
    left: Boolean,
    right: Boolean,
    rightTop: Boolean,
    noPadding: Boolean,
    tabIndex: { type: Number, default: 100 },
    isOpen: { type: Boolean, default: false },
    lockToggle: Number,
    darkBackground: { type: Boolean, default: false }, 
    forceDown: Boolean
  },
  data() {
    return {
      // open: false,

      //Trying to make one dropdown exclusive
      exclusive: this._uid,
      leftTop: false,
      leftTopPlacement: 0,
    };
  },

  computed: {
    open() {
      return this.$store.state.exclusiveDropdown == this.exclusive;
    },
    
    cssProps() {
      return {
        "--left-top": this.leftTopPlacement,
      };
    }
    
  },

  methods: {
    onBlur() {},
    onToggle(event) {
      //  this.open = !this.open
      if (this.lockToggle == this.exclusive && event) {
        this.$store.commit("setExclusiveDropdown", this.lockToggle);
      } else this.$store.commit("setExclusiveDropdown", this.open ? null : this.exclusive);
    },
    onOutsideClick(event) {
      if (this.open && this.$el && event && (event.type === "blur" || !this.$el.contains(event.target)))
        this.$store.commit("setExclusiveDropdown", null);
    },
    checkPosition() {
      if(this.forceDown) return
      const pos = this.$refs.dropdownmenu.getBoundingClientRect();
      if (window.innerHeight - 60 < pos.bottom) {
        this.leftTopPlacement = pos.height
        this.leftTop = true;
      } else this.leftTop = false;
    }
  },
  watch: {
    open(isOpen) {
      if (isOpen) this.$emit("opened");
      else this.$emit("closed");
      
      this.$nextTick(() => {
        this.checkPosition();
      });

    },
    $route() {
      if (this.open) this.open = false;
    },
    isOpen: {
      handler(open) {
        // this.open = open
        // this.$store.state.exclusiveDropdown = open // should be this one but messes with closing the dropdown, when clicking e.g. Create scenario below.
      },
      immediate: true
    }
  },
  mounted() {
    if (this.EventBus) this.EventBus.$on("app-click", this.onOutsideClick);
    else {
      if (!this.$root.outsideClickHandler) {
        this.$root.outsideClickHandler = (event) => this.$root.$emit("window-click", event);
        window.addEventListener("click", this.$root.outsideClickHandler);
      }
      this.$root.$on("window-click", this.onOutsideClick);
    }
    this.$on("close", () => {
      this.open = false;
    });
  },
  beforeDestroy() {
    if (this.EventBus) this.EventBus.$off("app-click", this.onOutsideClick);
    else this.$root.$off("window-click", this.onOutsideClick);
  }
};
</script>

<style lang="less">
.dropdown {
  display: inline-block;
  position: relative;
  &:focus,
  &:active {
    outline: none;
  }
  .disabled {
    cursor: default !important;
  }
  .toggle {
    cursor: pointer;
    display: inline-block;
    .dropdown-indicator {
      padding-left: 15px;
    }
  }
  .menu {
    box-shadow: 0 5px 10px 1px rgba(50, 50, 50, 0.1);
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 99;
    background-color: #fff;
    border-radius: var(--standard-border-radius);
    &.padding {
      padding: 10px 0;
    }
    .dropdown-item {
      font-size: 12px;
      line-height: 13px;
      color: #000;
      padding: 10px 20px;
      padding: 6px 12px;
      cursor: pointer;
      &:active {
        background-color: #f8f8f8;
      }
    }
    button.dropdown-item.active {
    background-color: var(--charcoal-10) ;
  }


    // .dropdown-description {
    //   padding: 10px 20px;
    //   font-size: 13px;
    //   color: #777;
    //   &.with-icon {
    //     display: flex;
    //     align-items: center;
    //     i {
    //       padding-right: 15px;
    //     }
    //   }
    // }

    .dropdown-divider::after {
      content: "";
      height: 1px;
      margin: 10px 0;
      border-top: 1px solid var(--text-grey-primary);
      display: block;
    }

    .dropdown-divider.small::after {
      margin: 0;
    }

    &.left {
      right: 0;
      left: unset;
      text-align: left;
    }

    &.right {
      left: 100%;
      right: 0;
    }
    &.right-top {
      left: 100%;
      top: 0;
    }
    &.left-top{
     
    }
  }
  .menu.dark-background {
    background-color: #333a3e;
    .dropdown-item {
      color: var(--alabaster);
      &:active,
      &:hover {
        background-color: var(--charcoal);
      }
    }
  }
}
</style>
